/**
 * Knop naar het Google Meet-gesprek dat bij deze kamer hoort.
 *
 * GEEN SCHERMTEKST OM TE VERTALEN, met opzet. "Google Meet" is een merknaam en
 * leest in elke taal hetzelfde; het camera-icoon zegt de rest. Zo kost deze
 * knop geen zestien vertalingen.
 *
 * Een nieuw tabblad, want dit tabblad IS het tolkgesprek. Wie hier weg
 * navigeert, verbreekt de kamer.
 *
 * `noreferrer`: Meet hoeft niet te weten via welke kamerlink je kwam - daar
 * staat het kamer-id in.
 */
export default function MeetKnop({
  link,
  compact = false,
}: {
  link: string | null;
  compact?: boolean;
}) {
  if (link === null) return null;
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className={`inline-flex items-center justify-center gap-2 rounded-xl bg-gio-blue text-white
                  font-bold shadow-sm hover:bg-gio-dark transition-colors duration-155
                  ${compact ? 'px-3 py-1.5 text-[11px]' : 'w-full py-2.5 text-sm'}`}
    >
      <svg
        viewBox="0 0 24 24"
        className={compact ? 'w-4 h-4' : 'w-5 h-5'}
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <rect x="2" y="6" width="13" height="12" rx="2" />
        <path d="M15 10l6-3.5v11L15 14" />
      </svg>
      <span>Google Meet</span>
      <span aria-hidden="true">↗</span>
    </a>
  );
}
